module.exports = __webpack_public_path__ + "img/the-obelisk-gate.c086ae47.png";